import { AddTaskSchema } from "../models/api";

interface ICalculateTaskTime {
  tasks: AddTaskSchema[];
  totalTimeInSeconds: number;
}

function updateTaskTime({ tasks, totalTimeInSeconds }: ICalculateTaskTime) {
  const totalTaskOccurrence = tasks.reduce((previous, current) => {
    const currentTaskCount = current.isMonthly
      ? current.totalTaskPerMonth
      : current.daysPerWeek;
    return previous + currentTaskCount!;
  }, 0);
  const timePerOccurrence = totalTimeInSeconds / totalTaskOccurrence;
  const timePerDayOccurrence = timePerOccurrence / 30;

  tasks.forEach((task) => {
    const taskOccurrence = task.isMonthly
      ? task.totalTaskPerMonth!
      : task.daysPerWeek!;
    task.secondsPerDay = timePerDayOccurrence * taskOccurrence;
  });

  return tasks;
}

function formatSecondToMinute(value: number) {
  if (!value || value <= 0) {
    return "";
  }
  return parseFloat(String(value / 60)).toFixed(2);
}

export const PatientTaskUtils = {
  updateTaskTime,
  formatSecondToMinute,
};
